import Box              from '@mui/material/Box';
import IconButton       from '@mui/material/IconButton';
import Typography       from '@mui/material/Typography';
import Close            from '@mui/icons-material/Close';
import useMediaQuery    from '@mui/material/useMediaQuery';
import useTheme         from '@mui/material/styles/useTheme';

// Shared modal-window chrome for the admin popups (Edit/Delete/Remove student,
// Edit/Delete class, QR codes, login guides). Matches the unified window spec:
// 520px wide, 64px edge padding, × at 32px-top / 64px-right (24px icon),
// centered title 88px from the top, 64px bottom — the same look as ClassFlow
// and the onboarding screens. Rendered inside the caller's <Dialog>.
const PopupWithCloseButton = (
    props: {
        closePopap: ()=>void,
        title: string,
        children: JSX.Element|JSX.Element[]
    }
) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    return(
        <Box sx={{
            position: 'relative',
            width: matches ? 520 : '100%',
            maxWidth: '100%',
            px: { xs: 3, sm: 8 },
            pt: 11,
            pb: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
        }}>
            <IconButton
                aria-label="close"
                onClick={props.closePopap}
                sx={{ position: 'absolute', top: 32, right: { xs: 24, sm: 64 }, p: 0, color: 'secondary.main' }}
            >
                <Close sx={{ fontSize: 24 }}/>
            </IconButton>
            <Typography variant="h6" textAlign="center">
                {props.title}
            </Typography>
            {props.children}
        </Box>
    );
};

export default PopupWithCloseButton;
